import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { getMe } from "./schema/auth/get-me";
import { sendMagicLink } from "./schema/auth/send-magic-link";
import { verifyMagicLink } from "./schema/auth/verify-magic-link";
import { createStore } from "./schema/stores/create-store";
import { createStoreApiToken } from "./schema/stores/create-store-api-token";
import { getStore } from "./schema/stores/get-store";
import { listStoreApiTokens } from "./schema/stores/list-store-api-tokens";
import { listStores } from "./schema/stores/list-stores";
import { revokeStoreApiToken } from "./schema/stores/revoke-store-api-token";

export const rpcDefinition = {
  sendMagicLink,
  verifyMagicLink,
  getMe,
  listStores,
  getStore,
  createStore,
  listStoreApiTokens,
  createStoreApiToken,
  revokeStoreApiToken,
} as const;

export type PartnersPortalRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
